import * as echarts from 'echarts';
import { DarkColors, LightColors } from 'types/colors';
import { ThemeMode } from 'types/theme';

echarts.registerTheme(ThemeMode.DARK, {
  backgroundColor: DarkColors.MAIN_BG_COLOR_2,
  legend: {
    textStyle: {
      color: DarkColors.MAIN_TEXT_COLOR,
      inactiveColor: '#494949',
      fontFamily: "'Satoshi', sans-serif",
    },
  },
});

echarts.registerTheme(ThemeMode.LIGHT, {
  backgroundColor: LightColors.MAIN_BG_COLOR_2,

  legend: {
    textStyle: {
      color: LightColors.MAIN_TEXT_COLOR,
      inactiveColor: '#494949',
      fontFamily: "'Satoshi', sans-serif",
    },
  },
});
